
import { page } from './stores';

export const Routes = {
    EMBED: 'embed',
    INDEX: 'index',
    INVITE_USER: 'invite-user',
    LIST: 'list',
    LOGIN: 'login',
    LOCATION: 'location',
    CREATE_ACCOUNT: 'create-account',
    TERMS_AND_CONDITIONS: 'terms-and-conditions',
    FORGOT_PASSWORD: 'forgot-password',
    EDIT_FOOTER: 'edit-footer',
    SETTINGS: 'settings',
};

export function pushRoute(route) {
    let path = `?p=${route}`;
    if (route === Routes.INDEX) {
        path = '/';
    }
    history.pushState({}, '', path);
    page.update(() => route);
}
